module.exports = __webpack_public_path__ + "assets/imperva.750bdf5f.svg";